import { EmailThread } from "../../../Components/MailApp/MailAppInterfaces";
import santaCamHeader from "./WhiteHouseMailAssets/SantaCam-Email.webp";
import NewsDigestHeader from "./WhiteHouseMailAssets/NewsDigested-Email.webp";
import CinemaHeader from "./WhiteHouseMailAssets/Cinema-Email.webp";
import CleaningSchedule from "./WhiteHouseMailAssets/CleaningSchedule.webp";
import TweeterHeader from "./WhiteHouseMailAssets/Tweeter-Email.webp";

export const WhiteHouseMail: EmailThread[] = [
  {
    Emails: [
      {
        Date: "8 Dec 2022",
        Time: "12:03pm",
        Author: "megalithcinema@mail.co",
        Receiver: "GeorgeMcFarlane@personalmail.co",
        Subject: "Special Screening of 'The Memory Weaver'",
        Text: `Celebrating the 25th anniversary of its release, the 1990s cult classic sci-fi movie, ‘The Memory Weaver’ comes to the big screen at D.C. 's Megalith this weekend. 

Kaminski won the top prize at Cannes for his final movie, this genre-bending sci-fi epic. Dr. Anya Kalista, a brilliant but troubled memory weaver can implant and manipulate memories within others.

When a powerful government official seeks to alter his past, Anya uncovers a dark conspiracy that threatens to rewrite history itself.

We hope to see you there!`,
        Signature: "Megalith Cinema",
        imageContent: CinemaHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "8 Dec 2022",
        Time: "9:34am",
        Author: "santacam@daily.co",
        Receiver: "GeorgeMcFarlane@personalmail.co",
        Subject: "Your SantaCam Update! 🎅",
        Text: `Thank you for using SantaCam. 

Log in to your SantaCam App to see your week’s highlights so far.
        
We hope that you continue to enjoy using santacam in the future!`,
        imageContent: santaCamHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "7 Dec 2022",
        Time: "7:54am",
        Author: "newsdigested@newsletter.co",
        Receiver: "GeorgeMcFarlane@personalmail.co",
        Subject: "Taiwan Crisis Deepens",
        Text: `Tensions between the United States and China are flaring once again, this time driven by a deepening crisis in the Taiwan Strait.

Reports of increased Chinese military activity near the island nation have rattled nerves in Taipei and Washington, raising concerns of a potential conflict. Our correspondents in the region explore the latest developments and what they mean for the fragile peace in the Indo-Pacific.

Read more online`,
        imageContent: NewsDigestHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "6 Dec 2022",
        Time: "7:46am",
        Author: "newsdigested@newsletter.co",
        Receiver: "GeorgeMcFarlane@personalmail.co",
        Subject: "Unrest in Egypt",
        Text: `Unrest in Egypt: Student Protests Raise Echoes of Arab Spring        

Students in Egypt are taking to the streets in a wave of protests, raising concerns of a growing social movement reminiscent of the 2011 Arab Spring uprisings.

The demonstrations, fueled by discontent over women’s rights, student debt, and Western economic hegemony in the region, mark a significant challenge to the current Egyptian government.

Our correspondents in Cairo explore the roots of the unrest and the potential for wider escalation.

Read more online`,
        imageContent: NewsDigestHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "5 Dec 2022",
        Time: "12:45pm",
        Author: "tweeter@notifyme.co",
        Receiver: "GeorgeMcFarlane@personalmail.co",
        Subject: "@JuliaUSPol mentioned you 🐦",
        Text: "@JuliaUSPol mentioned you in a tweet, 5 Dec 22",
        imageContent: TweeterHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "5 Dec 2022",
        Time: "12:03pm",
        Author: "WilliamBroder@WhiteHousestaff.co",
        Receiver: "GeorgeMcFarlane@personalmail.co",
        Subject: "Weekly Cleaning Schedule",
        Text: `Dear President,

See attached the weekly cleaning schedule.

Kind regards,
William`,
        imageContent: CleaningSchedule,
      },
    ],
  },
];
